import { makeStateKey } from '@angular/platform-browser';

export const STATE_KEY_SSR_REDIRECT = makeStateKey<string>('STATE_KEY_SSR_REDIRECT');
